const getCookieCheckUrl = (apiUrl: string) => `${apiUrl}/auth/cookie-check`;

const setCookieCheck = async (apiUrl: string) => {
  const response = await fetch(getCookieCheckUrl(apiUrl), {
    credentials: 'include',
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error(`Failed to set cookie check: ${response.status}`);
  }
};

const readCookieCheck = async (apiUrl: string): Promise<boolean> => {
  const response = await fetch(getCookieCheckUrl(apiUrl), {
    cache: 'no-store',
    credentials: 'include',
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Failed to read cookie check: ${response.status}`);
  }

  const payload = await response.json().catch(() => null);
  if (!payload || typeof payload.cookiesEnabled !== 'boolean') {
    throw new Error(`Invalid cookie check response: ${response.status}`);
  }

  return payload.cookiesEnabled;
};

const checkApiCookiesEnabled = async (apiUrl: string): Promise<boolean> => {
  await setCookieCheck(apiUrl);
  return readCookieCheck(apiUrl);
};

export { checkApiCookiesEnabled };
